import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import auditionApi from "api/auditionApi";

const CheckboxActiveAudition = ({
  item,
  isDisabled,
}: {
  item: any;
  isDisabled?: boolean;
}) => {
  const { t, i18n } = useTranslation();

  const [itemActive, setItemActive] = useState<any>(null);

  const handleOnConfirmUpdate = async (item: {
    id: number | string;
    is_active: number | boolean;
  }) => {
    try {
      if (!item) {
        return;
      }
      const response: any = await auditionApi.putAudition(item?.id, {
        is_active: item?.is_active,
      });

      if (response?.statusCode === 200) {
        setItemActive({
          id: item?.id,
          is_active: item?.is_active,
        });

        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  //   useEffect(() => {
  //     if (item) {
  //       setItemActive({
  //         is_active: item?.is_active,
  //         id: item?.id,
  //       });
  //     }
  //   }, [item]);

  return (
    <div
      className="form-check form-switch form-switch-sm text-center"
      dir="ltr"
      // style={{ width: 80 }}
    >
      <input
        type="checkbox"
        className="form-check-input"
        name="is_active"
        checked={itemActive ? itemActive?.is_active : item?.is_active}
        disabled={item?.is_deleted === 1}
        onChange={(e) => {
          if (isDisabled) return;

          const value = e?.target?.checked;
          handleOnConfirmUpdate({
            id: item?.id,
            is_active: !!value ? 1 : 0,
          });
        }}
      />
      {item?.is_deleted === 1 && (
        <div>
          <small className="text-danger">{t("Deleted")}</small>
        </div>
      )}
    </div>
  );
};

export default CheckboxActiveAudition;
